import {
    FETCH_KIOSKS,
    SAVE_KIOSK,
    DELETE_KIOSK,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_KIOSKS:
            return action.payload;
        case SAVE_KIOSK:
            if (action.meta && action.meta.kioskId) {
                return state.map(kiosk => kiosk.id === action.meta.kioskId ? action.payload : kiosk);
            }
            return state.concat(action.payload);
        case DELETE_KIOSK:
            return state.filter(kiosk => kiosk.id !== action.meta.kioskId);
        default:
            return state;
    }
};
